import { render, staticRenderFns } from "./JSelectProductTypes.vue?vue&type=template&id=22f1bb38&scoped=true&"
import script from "./JSelectProductTypes.vue?vue&type=script&lang=js&"
export * from "./JSelectProductTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1bb38",
  null
  
)

export default component.exports